var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.discountPercentage(_vm.product)),expression:"discountPercentage(product)"}],staticClass:"offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"},[_vm._v("\n    "+_vm._s(_vm.discountPercentage(_vm.product))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }